(function(){
  var header=document.querySelector('.fim-header');
  if(header){var onS=function(){header.classList.toggle('is-scrolled',window.scrollY>24)};window.addEventListener('scroll',onS,{passive:true});onS();}
  var els=document.querySelectorAll('[data-fim-reveal]');
  if('IntersectionObserver' in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el)});
  } else { els.forEach(function(el){el.classList.add('is-in')}); }
  var drawer=document.getElementById('FimMenu');
  if(drawer){
    var openers=document.querySelectorAll('[data-fim-menu-open]'),closers=drawer.querySelectorAll('[data-fim-menu-close]'),last=null;
    var open=function(e){last=e&&e.currentTarget;drawer.classList.add('is-open');drawer.removeAttribute('aria-hidden');document.body.style.overflow='hidden';openers.forEach(function(o){o.setAttribute('aria-expanded','true')});var f=drawer.querySelector('button,a');if(f)f.focus();};
    var close=function(){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';openers.forEach(function(o){o.setAttribute('aria-expanded','false')});if(last)last.focus();};
    openers.forEach(function(o){o.addEventListener('click',open)});
    closers.forEach(function(c){c.addEventListener('click',close)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('is-open'))close();});
  }
})();
/* Produktvorschau: unscharfer Hintergrund aus dem eigenen Produktbild (siehe fim-tweaks.css) */
(function(){
  var sel='.product-card-wrapper .card__media .media, .fim-card .fim-media';
  var fill=function(){
    document.querySelectorAll(sel).forEach(function(m){
      if(m.getAttribute('data-fim-bd'))return;
      var img=m.querySelector('img');if(!img)return;
      var src=img.getAttribute('src')||'';if(!src)return;
      src=/[?&]width=\d+/.test(src)?src.replace(/([?&]width=)\d+/,function(a,p){return p+'80';}):src+(src.indexOf('?')>-1?'&':'?')+'width=80';
      m.style.setProperty('--fim-bd','url("'+src+'")');
      m.setAttribute('data-fim-bd','1');
    });
  };
  var start=function(){
    fill();
    var t=null;
    new MutationObserver(function(){if(t)return;t=setTimeout(function(){t=null;fill();},60);}).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();